export default __webpack_public_path__ + "static/media/Girdle of Celestial Radiance.1d24a48a.jpg";